import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { Reveal, StaggerGroup } from "../../theme/animation";

interface RoleFaqsHeroProps {
  title: string;
  intro: string;
  roleSwitcher?: React.ReactNode;
  heroImageUrl?: string;
  anchorStrip?: React.ReactNode;
}

const RoleFaqsHero: React.FC<RoleFaqsHeroProps> = ({
  title,
  intro,
  roleSwitcher,
  heroImageUrl = "/images/athlete.jpg",
  anchorStrip,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: 380,
        backgroundImage: `url(${heroImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `linear-gradient(-90deg, 
          #00000015 0%, 
          #000000 75%)`,
        }}
      />
      {/* Overlay content */}
      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
          py: 6,
          color: "white",
        }}
      >
        {roleSwitcher && (
          <Reveal variant="fadeUp" trigger="mount">
            <Box sx={{ mb: 3 }}>{roleSwitcher}</Box>
          </Reveal>
        )}
        <Reveal variant="fadeUp" trigger="mount">
          <Typography variant="h3" component="h1" sx={{ fontWeight: "bold", mb: 2 }}>
            {title}
          </Typography>
        </Reveal>
        <Reveal variant="fadeUp" trigger="mount" delay={0.08}>
          <Typography variant="h6" sx={{ mb: 3, opacity: 0.95, maxWidth: 720 }}>
            {intro}
          </Typography>
        </Reveal>
        {anchorStrip && (
          <StaggerGroup stagger={0.08}>
            <Reveal variant="fadeUp" trigger="mount" delay={0.16}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>{anchorStrip}</Box>
            </Reveal>
          </StaggerGroup>
        )}
      </Container>
    </Box>
  );
};

export default RoleFaqsHero;
